import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'

import {
    REQUEST_PURCHASE_TEMPLATES,
    FETCH_PURCHASE_TEMPLATES_SUCCESS,
    FETCH_PURCHASE_TEMPLATES_FAILURE,
    SELECT_PURCHASE_TEMPLATE,
    RESET_CURRENT_PURCHASE_TEMPLATE,
    REQUEST_PURCHASE_TEMPLATE_DETAIL,
    FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS,
    FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE,
    REQUEST_CREATING_PURCHASE_TEMPLATE,
    CREATE_PURCHASE_TEMPLATE_SUCCESS,
    CREATE_PURCHASE_TEMPLATE_FAILURE,
    REQUEST_EDITING_PURCHASE_TEMPLATE,
    EDIT_PURCHASE_TEMPLATE_SUCCESS,
    EDIT_PURCHASE_TEMPLATE_FAILURE,
    REQUEST_PURCHASE_QUOTE_DETAIL,
    FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS,
    FETCH_PURCHASE_QUOTE_DETAIL_FAILURE,
    REQUEST_PURCHASE_SCHEDULE_DETAIL,
    FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS,
    FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE,
    DELETE_PURCHASE_TEMPLATE,
    DELETE_PURCHASE_TEMPLATE_SUCCESS,
    DELETE_PURCHASE_TEMPLATE_FAILURE,
    REQUEST_PURCHASE_TEMPLATE_LIST,
    FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS,
    FETCH_PURCHASE_TEMPLATE_LIST_FAILURE,

} from './type'

import {
    PURCHASE_TEMPLATES_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import {isGGI} from './root_url'

export function fetchPurchaseTemplates() {
    return dispatch => {
        dispatch(requestPurchaseTemplates());
        return axios.get(PURCHASE_TEMPLATES_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchPurchaseTemplatesSuccess(response));
            }, err => {
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                    document.getElementById('tokenInvalid').style.display = 'flex'
                    return
                  }
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchPurchaseTemplatesFailure(err));
            });
    }
}

export function requestPurchaseTemplates() {
    return {
        type: REQUEST_PURCHASE_TEMPLATES,
    };
}

export function fetchPurchaseTemplatesSuccess(purchaseTemplates) {
    return {
        type: FETCH_PURCHASE_TEMPLATES_SUCCESS,
        payload: purchaseTemplates
    };
}

export function fetchPurchaseTemplatesFailure(error) {
    return {
        type: FETCH_PURCHASE_TEMPLATES_FAILURE,
        payload: error
    };
}


export function selectPurchaseTemplate(purchaseTemplate) {
    return {
        type: SELECT_PURCHASE_TEMPLATE,
        payload: purchaseTemplate
    };
}


export function resetCurrentPurchaseTemplate() {
    return {
        type: RESET_CURRENT_PURCHASE_TEMPLATE
    }
}

// Fetch the detail page.

export function fetchPurchaseTemplateDetail(customer_id) {
    return dispatch => {
        dispatch(requestPurchaseTemplateDetail());
        return axios.get(PURCHASE_TEMPLATES_URL + customer_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchPurchaseTemplateDetailSuccess(response));
            }, err => {
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                    document.getElementById('tokenInvalid').style.display = 'flex'
                    return
                  }
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchPurchaseTemplateDetailFailure(err));
            });
    }
}

export function requestPurchaseTemplateDetail() {
    return {
        type: REQUEST_PURCHASE_TEMPLATE_DETAIL,
    };
}

export function fetchPurchaseTemplateDetailSuccess(purchaseTemplateDetail) {
    purchaseTemplateDetail = purchaseTemplateDetail.data;
    // The date data fetched is in the form of string, which needs to be modified into Date type
    if (purchaseTemplateDetail.OrderDate) purchaseTemplateDetail.OrderDate = new Date(purchaseTemplateDetail.OrderDate);
    if (purchaseTemplateDetail.ETADate) purchaseTemplateDetail.ETADate = new Date(purchaseTemplateDetail.ETADate);
    if (purchaseTemplateDetail.ReceivedDate) purchaseTemplateDetail.ReceivedDate = new Date(purchaseTemplateDetail.ReceivedDate);
    return {
        type: FETCH_PURCHASE_TEMPLATE_DETAIL_SUCCESS,
        payload: purchaseTemplateDetail
    };
}

export function fetchPurchaseTemplateDetailFailure(error) {
    return {
        type: FETCH_PURCHASE_TEMPLATE_DETAIL_FAILURE,
        payload: error
    };
}

export function createPurchaseTemplate({
    Name,
    NoteToVendor,
    ReleaseInformation,
    CarryType,
    ShippingMethod,
    Discount,
    ShippingCost,
    HandlingCost,
    MiscCost,
    MiscNote,
    ConvertItemPrice,
    Vendor_id,
    Pickup_VendorDetail_id,
    Deliver_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Purchaser_User_id,
    Modifier_User_id,
    PaymentStatus,
}, Purchase_Template_Line, TaxRate, CRV, FinalNetWeight, FinalShippingWeight,TotalPrice,FinalPrice) {
    Purchase_Template_Line.map(
        product => {
            if (product.Product_id)
                product.Product_id = product.Product_id.value || product.Product_id;
        }
    )
    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
    if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
    if (CarryType) CarryType = CarryType.value || CarryType;
    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
    if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_PURCHASE_TEMPLATE });
        axios.post(PURCHASE_TEMPLATES_URL,
            {
                Name,
                FinalNetWeight,
                FinalShippingWeight,
                TotalPrice,
                NoteToVendor,
                ReleaseInformation,
                CarryType,
                ShippingMethod,
                Discount,
                ShippingCost,
                HandlingCost,
                MiscCost,
                MiscNote,
                TaxRate,
                FinalPrice,
                ConvertItemPrice,
                Deliver_Warehouse_id,
                DispatchMethod_id,
                DispatchOutSourceContact_id,
                Purchaser_User_id,
                Modifier_User_id,
                Vendor_id,
                Pickup_VendorDetail_id,
                Purchase_Template_Line,
                PaymentStatus,
                CRV,
                ShippingMethod,

            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createPurchaseTemplateSuccess(response));
            }, err => {
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                    document.getElementById('tokenInvalid').style.display = 'flex'
                    return
                  }
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createPurchaseTemplateFailure(err));
            });
    }
}

export function createPurchaseTemplateSuccess(response) {
    return {
        type: CREATE_PURCHASE_TEMPLATE_SUCCESS,
        payload: response,
    }
}

export function createPurchaseTemplateFailure(error) {
    return {
        type: CREATE_PURCHASE_TEMPLATE_FAILURE,
        payload: error
    }
}

export function editPurchaseTemplate({
    PurchaseTemplate_id,
    Name,
    NoteToVendor,
    ReleaseInformation,
    CarryType,
    Discount,
    ShippingCost,
    HandlingCost,
    MiscCost,
    MiscNote,
    ConvertItemPrice,
    Vendor_id,
    Pickup_VendorDetail_id,
    Deliver_Warehouse_id,
    DispatchMethod_id,
    DispatchOutSourceContact_id,
    Purchaser_User_id,
    Modifier_User_id,
    PaymentStatus,
    ShippingMethod,
}, Purchase_Template_Line, TaxRate, CRV, FinalNetWeight, FinalShippingWeight,TotalPrice,FinalPrice) {
    Purchase_Template_Line.map(
        product => {
            if (product.Product_id)
                product.Product_id = product.Product_id.value || product.Product_id;
        }
    )
    if (Vendor_id) Vendor_id = Vendor_id.value || Vendor_id;
    if (Pickup_VendorDetail_id) Pickup_VendorDetail_id = Pickup_VendorDetail_id.value || Pickup_VendorDetail_id;
    if (CarryType) CarryType = CarryType.value || CarryType;
    if (PaymentStatus) PaymentStatus = PaymentStatus.value || PaymentStatus;
    if (ShippingMethod) ShippingMethod = ShippingMethod.value || ShippingMethod;
    if (Deliver_Warehouse_id) Deliver_Warehouse_id = Deliver_Warehouse_id.value || Deliver_Warehouse_id;
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_PURCHASE_TEMPLATE });
        axios.put((PURCHASE_TEMPLATES_URL + PurchaseTemplate_id),
            {
                Name,
                FinalNetWeight,
                FinalShippingWeight,
                TotalPrice,
                NoteToVendor,
                ReleaseInformation,
                CarryType,
                ShippingMethod,
                Discount,
                ShippingCost,
                HandlingCost,
                MiscCost,
                MiscNote,
                TaxRate,
                FinalPrice,
                ConvertItemPrice,
                Deliver_Warehouse_id,
                DispatchMethod_id,
                DispatchOutSourceContact_id,
                Purchaser_User_id,
                Modifier_User_id,
                Vendor_id,
                Pickup_VendorDetail_id,
                Purchase_Template_Line,
                PaymentStatus,
                ShippingMethod,
                CRV,

            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editPurchaseTemplateSuccess());
            }, err => {
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
                return
            }
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editPurchaseTemplateFailure(err));
            });
    }
}

export function editPurchaseTemplateSuccess() {
    return {
        type: EDIT_PURCHASE_TEMPLATE_SUCCESS
    }
}

export function editPurchaseTemplateFailure(error) {
    return {
        type: EDIT_PURCHASE_TEMPLATE_FAILURE,
        payload: error
    }
}

// Fetch the detail page.

export function convertTemplateToQuote(template_id) {
    return dispatch => {
        dispatch(requestConvertingTemplate());
        return axios.get(PURCHASE_TEMPLATES_URL + template_id + "/convert/",
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(convertTemplateSuccess(response));
            }, err => {
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                    document.getElementById('tokenInvalid').style.display = 'flex'
                    return
                  }
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(convertTemplateFailure(err));
            });
    }
}

export function requestConvertingTemplate() {
    return {
        type: REQUEST_PURCHASE_QUOTE_DETAIL,
    };
}

export function convertTemplateSuccess(purchaseQuoteDetail) {
    purchaseQuoteDetail = purchaseQuoteDetail.data;
    // The date data fetched is in the form of string, which needs to be modified into Date type
    if (purchaseQuoteDetail.OrderDate) purchaseQuoteDetail.OrderDate = new Date(purchaseQuoteDetail.OrderDate);
    if (purchaseQuoteDetail.ETADate) purchaseQuoteDetail.ETADate = new Date(purchaseQuoteDetail.ETADate);
    if (purchaseQuoteDetail.ReceivedDate) purchaseQuoteDetail.ReceivedDate = new Date(purchaseQuoteDetail.ReceivedDate);
    return {
        type: FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS,
        payload: purchaseQuoteDetail
    };
}

export function convertTemplateFailure(error) {
    return {
        type: FETCH_PURCHASE_QUOTE_DETAIL_FAILURE,
        payload: error
    };
}

export function convertTemplateToSchedule(template_id) {
    return dispatch => {
        dispatch(requestConvertingTemplateToSchedule());
        return axios.get(PURCHASE_TEMPLATES_URL + template_id + "/schedule/",
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(convertTemplateToScheduleSuccess(response));
            }, err => {
                if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                    document.getElementById('tokenInvalid').style.display = 'flex'
                    return
                  }
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(convertTemplateToScheduleFailure(err));
            });
    }
}

export function requestConvertingTemplateToSchedule() {
    return {
        type: REQUEST_PURCHASE_SCHEDULE_DETAIL,
    };
}

export function convertTemplateToScheduleSuccess(purchaseScheduleDetail) {
    purchaseScheduleDetail = purchaseScheduleDetail.data;
    // The date data fetched is in the form of string, which needs to be modified into Date type
    if (purchaseScheduleDetail.StartDate) purchaseScheduleDetail.StartDate = new Date(purchaseScheduleDetail.StartDate);
    if (purchaseScheduleDetail.NextExecuteDate) purchaseScheduleDetail.NextExecuteDate = new Date(purchaseScheduleDetail.NextExecuteDate);
    return {
        type: FETCH_PURCHASE_SCHEDULE_DETAIL_SUCCESS,
        payload: purchaseScheduleDetail
    };
}

export function convertTemplateToScheduleFailure(error) {
    return {
        type: FETCH_PURCHASE_SCHEDULE_DETAIL_FAILURE,
        payload: error
    };
}

export function deletePurchaseTemplate(template_id) {
  return dispatch => {
      dispatch({ type: DELETE_PURCHASE_TEMPLATE });
      return axios.delete(PURCHASE_TEMPLATES_URL + template_id,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(deletePurchaseTemplateSuccess());
            browserHistory.push('/purchaseTemplate'); // If editd succesfully, refresh the paymentTerm page.
          }, err => {
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
                return
              }
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(deletePurchaseTemplateFailure(err));
          });
  }
}

export function deletePurchaseTemplateSuccess() {
  return {
      type: DELETE_PURCHASE_TEMPLATE_SUCCESS
  }
}

export function deletePurchaseTemplateFailure(error) {
  return {
      type: DELETE_PURCHASE_TEMPLATE_FAILURE,
      payload: error
  }
}

export function fetchPurchaseTemplateList(pk) {
  return dispatch => {
      dispatch({type: REQUEST_PURCHASE_TEMPLATE_LIST});
      return axios.get(PURCHASE_TEMPLATES_URL + 'detail' + '/' + pk,
          {
              headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
          }
      )
          .then(response => {
            dispatch(fetchPurchaseTemplateListSuccess(response));
          }, err => {
            if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
                return
              }
            if (err.status === 500 || err.status === 404) {
              err.data = DEFAULT_ERROR;
            }
            dispatch(fetchPurchaseTemplateListFailure(err));
          });
  }
}

export function fetchPurchaseTemplateListSuccess(list) {
  return {
      type: FETCH_PURCHASE_TEMPLATE_LIST_SUCCESS,
      payload: list
  }
}

export function fetchPurchaseTemplateListFailure(error) {
  return {
      type: FETCH_PURCHASE_TEMPLATE_LIST_FAILURE,
      payload: error
  }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/purchaseTemplates_actions.js